export const AUTH_LOGIN = '/login';
export const AUTH_REGISTER = '/register';
export const AUTH_EMAIL_VERIFICATION = '/emailVerification';
export const AUTH_EMAIL_VERIFICATION_LOADING = '/emailVerificationLoading';
export const AUTH_FORGOT_PASSWORD = '/forgotPassword';
export const AUTH_RESET_PASSWORD = '/resetPassword';
